import { getSimpleDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from '../../store/rootReducer';

export const GreetingDataSelector = getSimpleDataSelector((state: RootState) => state.greeting);
